import { useState } from 'react';
import Room from '../../components/Room';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useGetReservQuery } from '../../redux/services/rooms/reservationAPI';
import { addDays } from 'date-fns';
import { FaCalendar, FaSearch } from 'react-icons/fa';

function RoomsList({ data, isError, error, isLoading, user }) {
  const { data: reservData } = useGetReservQuery();
  const allRooms = data?.ser_data || [];
  const [records, setRecords] = useState(allRooms);
  const [recordsbool, setRecordsbool] = useState(false);
  const [endDate, setEndDate] = useState(data?.state?.reservation ? addDays(new Date(data.state.reservation.exit_date), 1) : addDays(new Date(), 2));
  const [startDate, setStartDate] = useState(data?.state?.reservation ? addDays(new Date(data.state.reservation.entry_date), 1) : new Date());

  const dateFormat = (dateTime) => {
    const date = new Date(dateTime);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return [date.getFullYear(), month, day].join('-');
  };

  const handleSearch = () => {
    const entryDate = new Date(dateFormat(startDate));
    const exitDate = new Date(dateFormat(endDate));

    const excludedRooms = allRooms.filter((room) => {
      return !(reservData || []).some((reservation) => {
        const reservationEntryDate = new Date(reservation.entry_date);
        const reservationExitDate = new Date(reservation.exit_date);

        return (
          Number(room.id) === Number(reservation.room) &&
          (
            (reservationEntryDate <= entryDate && reservationExitDate >= exitDate) ||
            (reservationEntryDate <= entryDate && reservationExitDate >= entryDate) ||
            (reservationEntryDate >= entryDate && reservationEntryDate <= exitDate)
          )
        );
      });
    });

    setRecords(excludedRooms);
    setRecordsbool(true);
  };

  return (
    <section className="bg-surface py-12 sm:py-16">
      <div className="section-shell">
        <div className="mx-auto mb-10 max-w-3xl text-center">
          <span className="eyebrow">Stay booking</span>
          <h1 className="section-title mt-5">Find your next room</h1>
          <p className="section-copy">Filter by date and see available rooms with clear pricing, ratings, and booking details.</p>
        </div>

        <div className="premium-card bg-white p-4 sm:p-6">
          <div className="grid gap-4 lg:grid-cols-[1fr_1fr_auto] lg:items-end">
            <label className="block">
              <span className="mb-2 block text-xs font-bold uppercase tracking-wide text-muted">Entry date</span>
              <div className="relative">
                <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-gotrip-600">
                  <FaCalendar />
                </span>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => date && setStartDate(date)}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  minDate={new Date()}
                  className="field pl-11"
                />
              </div>
            </label>

            <label className="block">
              <span className="mb-2 block text-xs font-bold uppercase tracking-wide text-muted">Exit date</span>
              <div className="relative">
                <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-gotrip-600">
                  <FaCalendar />
                </span>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => date && setEndDate(date)}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  minDate={new Date()}
                  className="field pl-11"
                />
              </div>
            </label>

            <button type="button" onClick={handleSearch} className="btn-primary h-full min-h-[52px] lg:min-w-[180px]">
              <FaSearch /> Search rooms
            </button>
          </div>

          <div className="mt-4 flex flex-wrap items-center justify-between gap-3 rounded-2xl bg-gotrip-50 px-4 py-3">
            <p className="text-sm font-bold text-gotrip-800">
              Showing {recordsbool ? records.length : allRooms.length} {recordsbool ? records.length === 1 ? 'room' : 'rooms' : allRooms.length === 1 ? 'room' : 'rooms'}
            </p>
            <p className="text-sm text-muted">Availability updates when you search by date.</p>
          </div>
        </div>

        <div className="mt-12">
          <Room user={user} recordsbool={recordsbool} records={records} data={data} isError={isError} error={error} isLoading={isLoading}>
            <div>
              <span className="eyebrow">Curated rooms</span>
              <h2 className="section-title mt-5">Featured stays</h2>
              <p className="section-copy mx-auto">Premium rooms designed for comfort, clarity, and effortless booking.</p>
            </div>
          </Room>
        </div>
      </div>
    </section>
  );
}

export default RoomsList;
